import React from 'react'
import PropTypes from 'prop-types'
import Hero from 'components/Hero'
import Footer from 'components/Footer'
import GenericContent from 'components/GenericContent'
import FormContainer from 'components/PagesLayout/ContactPageLayout/FormContainer'
import {
  GenericContainer,
  GenericTitle,
  GenericBody,
  GenericLayout,
} from './styles'

const GenericPagesLayout = ({ query, children }) => {
  const data = query?.allPrismicGenericTemplate?.nodes?.[0]?.data || query?.data

  const heroQuery = {
    body: data.hero_body,
    title: data.hero_title,
    title_style: 'small',
    className: 'HeroGeneric',
  }

  return (
    <>
      <GenericContainer>
        <Hero {...heroQuery} />
        <GenericLayout>
          {data?.generic_title?.text && data?.generic_content?.html ? (
            <>
              <GenericTitle as="h2" type="h2">
                {data?.generic_title?.text}
              </GenericTitle>
              <GenericBody
                type="primary"
                as="span"
                dangerouslySetInnerHTML={{
                  __html: data?.generic_content?.html,
                }}
              />
            </>
          ) : query.data ? (
            <GenericContent query={query.data}>{children}</GenericContent>
          ) : (
            <></>
          )}
        </GenericLayout>
        <FormContainer {...query.data} />
        {query ? <Footer query={query} /> : <></>}
      </GenericContainer>
    </>
  )
}

GenericPagesLayout.propTypes = {
  query: PropTypes.object.isRequired,
  globalQuery: PropTypes.object,
}

export default GenericPagesLayout
